export default "__VITE_ASSET__D968BYez__"